import React from 'react';
import { ListSeats, ListSeatsItem, SeatsItemImg, ListRowsItem } from '../styles';
import { t } from 'i18next';
const countryCode = process.env.REACT_APP_COUNTRY;

class PlanBuilder {
  constructor(notify, plan, proceedTicketsBooking, width, buildContentStaticUrl) {
    const shouldSort = plan?.rows?.some((seat, index, array) => {
      const hasDuplicatePhysicalName = array?.findIndex((otherSeat) => otherSeat?.physicalName === seat?.physicalName) !== index;
      const allSeatsHaveDoubleSeatId = seat?.seats?.every((s) => s.doubleSeatId);
      return hasDuplicatePhysicalName && allSeatsHaveDoubleSeatId;
    });
    this.allIcons = plan.icons;
    this.notify = notify;
    if (shouldSort) {
      const newData = plan?.rows?.sort((a, b) => {
        const naturalSort = (a, b) => {
          const chunk = /(\d+)|(\D+)/g;
          const chunkA = String(a).match(chunk);
          const chunkB = String(b).match(chunk);

          while (chunkA.length && chunkB.length) {
            const chunkANumeric = !isNaN(chunkA[0]);
            const chunkBNumeric = !isNaN(chunkB[0]);

            if (chunkANumeric !== chunkBNumeric) {
              return chunkANumeric ? 1 : -1;
            } else if (chunkANumeric) {
              if (+chunkA[0] !== +chunkB[0]) {
                return +chunkA[0] - +chunkB[0];
              }
            } else if (chunkA[0] !== chunkB[0]) {
              return chunkA[0] < chunkB[0] ? -1 : 1;
            }

            chunkA.shift();
            chunkB.shift();
          }

          return chunkA.length - chunkB.length;
        };
        // const physicalNameComparison = a.physicalName.localeCompare(b.physicalName);
        const physicalNameComparison = naturalSort(a.physicalName, b.physicalName);
        if (physicalNameComparison === 0 && a?.seats[0]?.doubleSeatId !== '' && b?.seats[0].doubleSeatId !== '') {
          return a?.seats[0]?.columnIndex - b?.seats[0].columnIndex;
        }
        return physicalNameComparison;
      });
      this.allRows = newData;
    }
    else {
      this.allRows = plan.rows;
    }
    // this.allRows = plan.rows;
    this.oneSeatPercentLength = 100 / plan.rowsMax;
    /* eslint-disable no-param-reassign */
    this.maxRowLength =
      plan.rowsMax +
      this.allRows.reduce((acc, row) => {
        if (acc === 0 && plan.rowsMax === row.columnCount) {
          acc = Math.round(row.right / this.oneSeatPercentLength);
        }

        return acc;
      }, 0);
    /* eslint-enable no-param-reassign */
    this.proceedTicketsBooking = proceedTicketsBooking;
    this.gap = 5;
    this.rowLengthPx = width;
    this.seatLengthPercents = 100 / this.maxRowLength;
    this.rowLabelFontSize =
      (this.rowLengthPx - this.maxRowLength * this.gap) / this.maxRowLength -
      this.seatLengthPercents;
    this.rowIndexes = {};
    this.buildContentStaticUrl = buildContentStaticUrl;
  }

  getOneSeatMarkup(isDisabled, data, iconInfo, width = null, statusCalculated, rowName, multipleSeats) {
    const key = data.rowIndex.toString() + data.columnIndex + data.areaNumber;
    let iconImgSrc;

    if (typeof iconInfo !== 'string' && iconInfo.length) {
      iconImgSrc = statusCalculated === 99 ? this.allIcons[3].imageUrl : iconInfo[0];
    } else {
      iconImgSrc = statusCalculated === 99 ? this.allIcons[2].imageUrl : iconInfo;
    }

    iconImgSrc = this.buildContentStaticUrl(iconImgSrc);

    return (
      <ListSeatsItem
        key={key}
        tabIndex={isDisabled || statusCalculated === 99 ? '-1' : '0'}
        width={width}
        className={(statusCalculated === 1 ? '_disabled' : countryCode === "svn" && statusCalculated === 3 ? '_disablewheelchair' : null) || (statusCalculated === 99 ? '_selected' : null)}
        onClick={e => {
          e.target.parentNode.blur();
          if (countryCode === "svn" && statusCalculated === 3) {
            this.notify('warning', t('common.wheelchair_seat_error'));
            return;
          }
          this.proceedTicketsBooking(width === 2 ? { ...data, columnIndex: data?.columnIndex - 1, columnIndexRender: data?.columnIndexRender - 1, columnIndexVista: data?.columnIndexVista - 1 } : data);
        }}
        onKeyUp={e => {
          if (e.keyCode !== 13) return;
          e.target.blur();
          this.proceedTicketsBooking(width === 2 ? { ...data, columnIndex: data?.columnIndex - 1, columnIndexRender: data?.columnIndexRender - 1, columnIndexVista: data?.columnIndexVista - 1 } : data);
        }}
        oneSeatLength={this.seatLengthPercents}
        gap={this.gap}
        rowName={rowName}
        multipleSeats={multipleSeats}
        index={data.columnIndex}
      >
        <div>
          <SeatsItemImg src={iconImgSrc} />
        </div>
      </ListSeatsItem>
    );
  };

  getOneRowMarkup(rowName, seatsArr, offsetRight, rowToMarkup = null) {
    const multipleSeats = {};
    const markedUpRow = rowToMarkup || [];
    const shouldSort = this.allRows?.some((seat, index, array) => {
      const hasDuplicatePhysicalName = array?.findIndex((otherSeat) => otherSeat?.physicalName === seat?.physicalName) !== index;
      const allSeatsHaveDoubleSeatId = seat?.seats?.every((s) => s.doubleSeatId);
      return hasDuplicatePhysicalName && allSeatsHaveDoubleSeatId;
    });
    for (let i = 0; i < this.maxRowLength; i += 1) {
      if (shouldSort && markedUpRow[i + 1] && !markedUpRow[i] && markedUpRow[i + 1]?.props?.width !== null) {
        continue;
      }
      if (!markedUpRow[i]) {
        markedUpRow[i] = (
          <ListSeatsItem
            key={`${rowName}__${i}`}
            oneSeatLength={this.seatLengthPercents}
            gap={this.gap}
            className={`${rowName}__${i}`}
          />
        );
      }
      // if (markedUpRow[i]?.doDelete || markedUpRow[i]._store?.validated) {
      if (markedUpRow[i].doDelete) {
        delete markedUpRow[i];
      }
      if (!seatsArr[i]) { continue; }

      const seat = seatsArr[i];
      const { columnIndex, seatImprovedIconId, position, statusCalculated } = seat;
      const iconSrc = `${this.allIcons[seatImprovedIconId || 0].imageUrl}`;
      const calculatedOffsetRight = Math.round(offsetRight / this.seatLengthPercents);
      const isDisabled = statusCalculated === 1;
      const index = calculatedOffsetRight > 0 ? columnIndex + calculatedOffsetRight : columnIndex;
      if (seat.seatsInGroup.length) {
        if (!multipleSeats.seatsInGroup || !multipleSeats.seatsInGroup.length) {
          multipleSeats.seatsInGroup = seat.seatsInGroup;
          multipleSeats.icons = [iconSrc];
        } else {
          multipleSeats.icons.push(iconSrc);
        }
      }


      if (multipleSeats.seatsInGroup && multipleSeats.seatsInGroup.length) {
        if (multipleSeats.seatsInGroup.indexOf(columnIndex) === multipleSeats.seatsInGroup.length - 1) {
          markedUpRow[index] = this.getOneSeatMarkup(
            isDisabled,
            position,
            multipleSeats.icons,
            multipleSeats.seatsInGroup.length,
            statusCalculated,
            rowName,
            multipleSeats.seatsInGroup
          );
          multipleSeats.seatsInGroup = [];
          // if (markedUpRow[index - 1]) {
          //   // delete markedUpRow[index - 1];
          //   if (i === index - 1 || i - 1 === index - 1) {
          //     delete markedUpRow[index - 1];
          //   }
          //   else {
          //     if (markedUpRow[index - 1]?._store) {
          //       markedUpRow[index - 1]._store.validated = true;
          //     }
          //     else {
          //       markedUpRow[index - 1] = { doDelete: true };
          //     }
          //   }
          // } else {
          //   markedUpRow[index - 1] = { doDelete: true };
          // }
          if (markedUpRow[index - 1]) {
            delete markedUpRow[index - 1];
          } else {
            markedUpRow[index - 1] = { doDelete: true };
            // markedUpRow[index - 1] = null;
          }
        }
      } else {
        markedUpRow[index] = this.getOneSeatMarkup(
          isDisabled,
          position,
          iconSrc,
          null,
          statusCalculated,
          rowName
        );
      }
    }

    return markedUpRow;
  }

  getAllRowsMarkup() {
    /* eslint-disable no-param-reassign */
    const markup = this.allRows.reduce((markedUpRows, row) => {
      const { physicalName, seats, right } = row;
      const rowIndexByPhysicalName = this.rowIndexes[physicalName];
      const completedRow = { physicalName, seats: [] };

      if (!seats?.length) {
        markedUpRows.push(completedRow);
        return markedUpRows;
      }

      if (rowIndexByPhysicalName !== undefined) {
        const seatsArr = [...markedUpRows[rowIndexByPhysicalName].seats];

        markedUpRows[rowIndexByPhysicalName].seats = this.getOneRowMarkup(
          physicalName,
          seats,
          right,
          seatsArr
        );
      } else {
        this.rowIndexes[row.physicalName] = markedUpRows.length;
        completedRow.seats = this.getOneRowMarkup(physicalName, seats, right);
        markedUpRows.push(completedRow);
      }

      return markedUpRows;
    }, []);
    /* eslint-enable no-param-reassign */

    this.rowIndexes = {};

    return markup;
  }

  getCompletedMarkup() {
    const allRows = this.getAllRowsMarkup();

    /* eslint-disable no-param-reassign */
    return allRows.reduce((listSeats, row, rowIndex, rowsArr) => {
      const { seats, physicalName } = row;
      const isExtraMarginNeeded = rowIndex !== 0 && !rowsArr[rowIndex - 1].seats.length;

      if (seats.length) {
        listSeats.push(
          <ListRowsItem
            key={`row__${physicalName}`}
            gap={this.gap}
            isExtraMarginNeeded={isExtraMarginNeeded}
            isFirstRow={rowIndex === 0}
            rowName={physicalName}
            fontSize={this.rowLabelFontSize > 30 ? 24 : this.rowLabelFontSize}
          // fontSize={this.rowLabelFontSize}
          >
            <ListSeats gap={this.gap}>{seats.reverse()}</ListSeats>
          </ListRowsItem>
        );
      }

      return listSeats;
    }, []);
    /* eslint-enable no-param-reassign */
  }
}

export default PlanBuilder;
